import CustomArrayChipField from "components/CustomArrayChipField";
import React from "react";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  ListProps,
  ReferenceInput,
  SelectInput,
} from "react-admin";
import StatusField from "../../components/StatusField";
import ListWrapper from "../../components/ListWrapper";

const UserFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <ReferenceInput
      label="Role"
      source="RoleId"
      filter={{ IsOnlyForAdmin: true }}
      reference="roles"
      alwaysOn
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const UserList = (props: ListProps) => {
  const breadcrumb = [{ link: "/users", title: "Users" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Users"
        isNotHaveSchoolFilter
        denseMode
        exporter={false}
        filters={<UserFilter />}
        bulkActionButtons={false}
        {...props}
      >
        <Datagrid rowClick="show">
          <TextField source="id" />
          <TextField source="email" label="Email" />
          <CustomArrayChipField
            source="roles"
            chipSource="name"
            label="Roles"
          />
          <StatusField label="Status" source="admin.status" />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default UserList;
